import { FlexBox } from '../../../components/Base/Base'
import { Text } from '../../../components/Text/Text'
import { User } from '../../../models/user'
import { lightGray1 } from '../../../theme/colors'
import { OverviewPerformanceScore } from './OverviewPerformanceScore'
import { OverviewSafetyScore } from './OverviewSafetyScore'

interface OverviewSectionProps {
  user: User
  isInsideSidebar?: boolean
}

export function OverviewSection({ user, isInsideSidebar }: OverviewSectionProps) {
  return (
    <FlexBox isColumn>
      <OverviewSafetyScore user={user} isInsideSidebar={isInsideSidebar} />

      <OverviewPerformanceScore user={user} isInsideSidebar={isInsideSidebar} />

      <FlexBox mt={6} justifyContent="center" alignItems="center">
        <Text variant="header6" fontColor={lightGray1}>
          Revenue information coming soon!
        </Text>
      </FlexBox>
    </FlexBox>
  )
}
